import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * 唯一正式业务分区卡片。
 * - variant="ledger"：台账分区。存在 filters / action 时，头部只显示标题、图标与总量 meta，
 *   控制项与标题同一视觉行；不得显示 description 小字。
 * - 默认分区：图标 + 标题 + meta + 简短说明，用于详情、表单与状态卡片。
 * - 分区级控制（日期切换、刷新、批量操作等）必须放入 filters / action 槽，归属对应分区。
 */
export function SectionCard({ icon: Icon, title, meta, description, filters, action, children, variant = "default", className = "" }: {
  icon: LucideIcon;
  title: string;
  meta?: ReactNode;
  description?: string;
  filters?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  variant?: "default" | "ledger";
  className?: string;
}) {
  const hasControls = Boolean(filters || action);
  return <section className={`section-card ${variant === "ledger" ? "section-card-ledger" : ""} ${variant === "ledger" && hasControls ? "section-card-ledger-controlled" : ""} ${className}`.trim()}>
    {(variant === "ledger" && hasControls) ? (
      <header className="section-card-head section-card-head-row">
        <div className="section-card-title">
          <span className="section-card-icon"><Icon size={17} aria-hidden /></span>
          <h3>{title}</h3>
          {meta && <span className="section-card-meta">{meta}</span>}
        </div>
        <div className="section-card-controls">{filters}{action}</div>
      </header>
    ) : (
      <header className="section-card-head">
        <div className="section-card-title">
          <span className="section-card-icon"><Icon size={17} aria-hidden /></span>
          <h3>{title}</h3>
          {meta && <span className="section-card-meta">{meta}</span>}
        </div>
        {action && <div className="section-card-controls">{action}</div>}
        {description && <p className="section-card-description">{description}</p>}
      </header>
    )}
    {filters && !(variant === "ledger" && hasControls) ? <div className="section-card-controls">{filters}</div> : null}
    <div className="section-card-body">{children}</div>
  </section>;
}
